export const sleep = async (msTime: number) =>
  new Promise<void>(resolve =>
    setTimeout(() => {
      resolve();
    }, msTime),
  );
